import type { Metadata } from '@/stores/ImageMetadata';

export function hasTagsCheck(
    meta: Metadata | undefined | null,
    tagReadServiceId: string,
): boolean {
    /* console.log('hasTags', { meta, tagReadServiceId, inspection: [
        !!meta,
        meta?.tags || undefined,
        meta?.tags[tagReadServiceId] || undefined,
        meta?.tags[tagReadServiceId]?.storage_tags || undefined,
        !!meta?.tags[tagReadServiceId]?.storage_tags
    ]}) */
    return !!meta?.tags[tagReadServiceId]?.storage_tags;
}
